export default __webpack_public_path__ + "static/media/Kayaking.b02fc647.svg";